/** ### Font Size Tokens
 * ---
 * There are twelve font size tokens. Each token key corresponds to a pixel value.
 * So if you're looking for a token that matches 16px, you'd grab the `fontSizes[16]` token.
 * But it's important to note that the value of each token is converted to base-16 rem.
 *
 * E.g. `fontSizes[16]` returns `'1rem'`
 *
 * Here's a quick reference for all font size tokens:
 * - 10, 12, 14, 16, 18, 20, 24, 28, 32, 40, 48, 56
 *
 * @example
 * ```tsx
 * import { type } from '@workday/canvas-kit-react/tokens';
 *
 * const LargeText = () => (
 *   <p css={{fontSize: type.properties.fontSizes[20]}}>
 *     Bold Text
 *   </p>
 * );
 * ```
 */
export const fontSizes = {
    10: '0.625rem',
    12: '0.75rem',
    14: '0.875rem',
    16: '1rem',
    18: '1.125rem',
    20: '1.25rem',
    24: '1.5rem',
    28: '1.75rem',
    32: '2rem',
    40: '2.5rem',
    48: '3rem',
    56: '3.5rem',
};
